/* eslint-disable react/no-danger */
import * as React from 'react';

import type { CmlContent, Submission_HtmlContent as HtmlContent } from '__generated__/graphql-types';

import CML from 'bundles/cml/legacy/components/CMLViewer';
import type { CmlContent as NaptimeCmlContent } from 'bundles/cml/legacy/types/Content';

import CMLUtils from '../utils/CMLUtils';

type Props = {
  value?: string | CmlContent | HtmlContent;
  assumeStringIsHtml?: boolean;
  isControlled?: boolean;
  className?: string;
  display?: 'inline-block' | undefined;
  shouldRenderFillableBlanksV2?: boolean;
};

const convertToNaptimeCml = (value: CmlContent): NaptimeCmlContent => {
  const naptimeCml = CMLUtils.create(value.cmlValue, value.dtdId);
  if (value.htmlWithMetadata) {
    naptimeCml.definition.renderableHtmlWithMetadata = {
      renderableHtml: value.htmlWithMetadata.html,
      metadata: value.htmlWithMetadata.metadata,
    };
  }
  return naptimeCml;
};

/**
 * Use this component to render CML/HTML/Text from GraphQL data
 */
/** @deprecated we only use HTML storage for legacy workflows, please use one of the other CML viewers to support new development */
const CMLOrHTML = ({ value, className, assumeStringIsHtml = true, ...rest }: Props) => {
  if (!value) {
    return null;
  }

  if (typeof value === 'object') {
    if (value.__typename === 'Submission_HtmlContent') {
      return <span className={className} dangerouslySetInnerHTML={{ __html: value.value }} />;
    } else if (value.__typename === 'CmlContent' || 'cmlValue' in value) {
      const cmlValue = convertToNaptimeCml(value);
      return <CML cml={cmlValue} {...rest} isCdsEnabled />;
    }
    return null;
  } else if (assumeStringIsHtml) {
    return <span className={className} dangerouslySetInnerHTML={{ __html: value }} />;
  } else {
    return <span className={className}>{value}</span>;
  }
};

export default CMLOrHTML;
